import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "6 5 20 22",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8 7h4.2v18H8z" }, null, -1),
    _createElementVNode("path", { d: "M19.6 7h-4.3c0 3.6-1.6 6.8-4.3 8.9l-.9.7L15.9 25h5.3l-4.5-6.6C18.9 15.5 19.6 11.4 19.6 7z" }, null, -1),
    _createElementVNode("circle", {
      cx: "23.6",
      cy: "22.8",
      r: "2.3"
    }, null, -1)
  ]))]))
}
export default { render: render }